<template>
     <div>
        <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>
        <div class="List">
            <!--查詢功能列-->
            <b-row>
                <b-col>
                    <!--群組名稱-->
                    <b-form-input
                        placeholder="請輸入群組名稱"
                        v-model="search.groupName">
                    </b-form-input>
                </b-col>
                <b-col cols="2">
                    <!--清除按鈕-->
                    <b-button @click="cancelSearch" v-if="checkSearchIsEmpty()" title="清空查詢條件">
                        <b-icon icon="x-circle"></b-icon>
                    </b-button>
                    <!--查詢按鈕-->
                    <b-button @click="startSearch" title="開始查詢">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </b-col>
                <b-col cols="2">
                    <!--新增按鈕-->
                    <b-button
                    @click="gotoContent()" >
                        新增
                    </b-button>
                </b-col>
            </b-row>
            <!--列表本體-->
            <b-container>
                <b-table-simple>
                    <b-thead>
                        <b-th>群組名稱</b-th>
                        <b-th>建檔人員</b-th>
                        <b-th >修改</b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="item in DataList" :key="item.AG_ID" v-if="blacklist.filter(x =>x.value == item.AG_ID).length == 0">
                            <b-td>{{ item.AG_NAME }}</b-td>
                            <b-td>{{ item.creatorName}}</b-td>
                            <!--功能按鈕-->
                            <b-td>
                                <b-button 
                                    class="mr-5"
                                    variant="info"
                                    @click="gotoContent(item.AG_ID)">
                                    編輯
                                </b-button>
                                <a href="javascript:void(0)"
                                    class="btn-delete"
                                    @click="functionDelete(item)">
                                   <img src="/images/backend/del_icon.png" alt="刪除icon" />
                                </a>
                            </b-td>   
                        </b-tr>     
                    </b-tbody>
                </b-table-simple>
            </b-container>
            <div class="page mt-2">
                <span class="pagination-total">共 {{Math.ceil(pagination.rows/pagination.perPage)}} 頁．{{pagination.rows}}筆資料</span>
                <b-pagination
                class="pagination light-theme simple-pagination"
                v-model="pagination.page"
                :total-rows="pagination.rows"
                :per-page="pagination.perPage"
                aria-controls="my-table">
                </b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import DeleteModal from "../../Tool/deleteModal.vue";
export default{ 
    components:{
        DeleteModal,
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            //樣式編號
            modal:"",
            //查詢資訊
            search:{},
            //列表設定
            pagination: {
                perPage: 10,
                page: 1,
                rows: 5,
            },
            //刪除模板
            deleteModal: {
                id: null,
                classes: null,
                parent: null,
                show: false,
                type: "AccountGroup",
            },
            //列表資料
            DataList:[],
            //排除編號
            blacklist:[
                {value:"AG7tyaLW8sSd2VvcW4q6Jww"},
            ]
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //樣式編號
            this.modal = this.value.modal;
            //取得畫面權限
            this.getPermission(this.PJ_ID);
            //開始查詢
            this.startSearch();
        },
        //開始查詢
        async startSearch(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE:"LIST",
                    ACCOUNT_GROUP_SELECT: {
                        keywords: this.search.groupName,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/AccountGroup",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    this.DataList = jsonData.outData;
                    this.pagination.rows = jsonData.totalCount;
                }
            }catch(err){
                console.log("ErrFunction: startSearch/n "+err);
            }
        },
        //跳轉至編輯頁面
        gotoContent(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:3,
                    id:gotoid,
                }
            });
        },

        //清除查詢資訊
        cancelSearch(){
            //清空查詢條件
            this.search={status:null ,AG_ID:null};
            //重新查詢事件
            this.startSearch();
        },
        //刪除功能
        functionDelete(item) {
            this.deleteModal.show = true;
            this.deleteModal.id = item.AG_ID;
            this.deleteModal.type = "AccountGroup";
            this.deleteModal.langurage = 1;
            this.deleteModal.VerifyCode = this.PJ_ID;
        },
    }
}
</script>